module.exports = __webpack_public_path__ + "img/default-avatar.f561b213.svg";